import { render, staticRenderFns } from "./participant-dob-section.vue?vue&type=template&id=b9679750&scoped=true&"
import script from "./participant-dob-section.vue?vue&type=script&lang=js&"
export * from "./participant-dob-section.vue?vue&type=script&lang=js&"
import style0 from "./participant-dob-section.vue?vue&type=style&index=0&id=b9679750&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9679750",
  null
  
)

component.options.__file = "participant-dob-section.vue"
export default component.exports